import { Outlet } from "react-router-dom";
import styled from "styled-components";
import { SP_BREAKPOINT } from "../../constants/app";
import { useSidebar } from "../../hooks/useSidebar";
import { Sidebar } from "../organisms/sidebar/Sidebar";
import { SidebarSP } from "../organisms/sidebar/SidebarSP";

export const SideBarTemplate: React.FC = () => {
  const {
    clientName,
    username,
    showSidebarSP,
    sidebarMenusToShow,
    selectedMenuPath,
    onSidebarMenuClick,
    onSidebarSPClick,
    handleLogout,
  } = useSidebar();

  return (
    <StyledSideBarTemplateContainer>
      <StyledSideBarContainter>
        <Sidebar
          clientName={clientName}
          username={username}
          sidebarMenusToShow={sidebarMenusToShow}
          selectedMenuPath={selectedMenuPath}
          onSidebarMenuClick={onSidebarMenuClick}
          handleLogout={handleLogout}
        />
        <SidebarSP
          clientName={clientName}
          username={username}
          sidebarMenusToShow={sidebarMenusToShow}
          selectedMenuPath={selectedMenuPath}
          onSidebarMenuClick={onSidebarMenuClick}
          showSidebarSP={showSidebarSP}
          onSidebarSPClick={onSidebarSPClick}
          handleLogout={handleLogout}
        />

        <StyledOutletContainer>
          <Outlet />
        </StyledOutletContainer>
      </StyledSideBarContainter>
    </StyledSideBarTemplateContainer>
  );
};

const StyledSideBarTemplateContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    justify-content: flex-start;
  }

  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
`;

const StyledSideBarContainter = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    flex-direction: column;
  }

  width: 100%;
  display: flex;
  align-items: center;
`;

const StyledOutletContainer = styled.div`
  @media (max-width: ${SP_BREAKPOINT}) {
    height: calc(100vh - 60px);
  }

  width: 100%;
  height: 100vh;
  display: flex;
`;
